import { observer, inject } from 'mobx-react';
import React from 'react';
import { Instance } from 'mobx-state-tree';
import moment from 'moment';
import { DutyAssignment } from '../../store/models/DutyAssignment';
import { Checkbox, Colors } from '@blueprintjs/core';
import styled from '@emotion/styled';
import { SystemStatus } from '../../store/models/SystemStatus';
import config from '../../config';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import { AuthenticationStore, ModalStore } from '../../store';

const ContrainerCheckbox = styled.div({
  '& .bp3-control': {
    marginBottom: '0px',
  },
});

interface DutySelectionProps {
  dutyList: Array<Instance<typeof DutyAssignment>>;
  onChange: (ids: number[]) => void;
  isInConflict: (id: number) => boolean;
  hasAlreadyDutyOn: (id: number) => boolean;
  systemStatus?: Array<Instance<typeof SystemStatus>>;
  pharmacyUser: boolean;
  disable?: boolean;
  selectedDuties: number[];
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  ModalStore?: Instance<typeof ModalStore>;
}

@inject('AuthenticationStore')
@inject('ModalStore')
@observer
class DutySelection extends React.Component<DutySelectionProps & WithTranslateProps> {
  onCheckboxChange = async (dutyAssignmentId) => {
    const hasAlreadyDutyOnDate = await this.props.hasAlreadyDutyOn(dutyAssignmentId);
    if (hasAlreadyDutyOnDate) {
      this.props.ModalStore!.confirm.disableCancel(true);
      await this.props.ModalStore!.confirm.show(
        this.props.translate(TLCode.GENERAL_Warning),
        this.props.translate(TLCode.EXCHANGE_ConflictDutyDate),
        false,
      );
      return;
    }

    const conflicts = await this.props.isInConflict(dutyAssignmentId);
    if (
      !conflicts ||
      (await this.props.ModalStore!.confirm.show(
        this.props.translate(TLCode.GENERAL_Warning),
        this.props.translate(TLCode.EXCHANGE_ConflictSecretariat),
      ))
    ) {
      let { selectedDuties } = this.props;
      if (selectedDuties!.includes(dutyAssignmentId)) {
        selectedDuties = selectedDuties!.filter((id) => id !== dutyAssignmentId);
      } else {
        selectedDuties!.push(dutyAssignmentId);
      }
      this.props.onChange(selectedDuties);
    }
  };

  toggleColor = (color) => {
    if (color == Colors.WHITE) {
      return Colors.LIGHT_GRAY4;
    } else {
      return Colors.WHITE;
    }
  };

  render() {
    const { dutyList, selectedDuties } = this.props;

    dutyList.sort((a, b) => {
      const dateA = new Date(a.duty!.dutyDate.date);
      const dateB = new Date(b.duty!.dutyDate.date);
      return dateA > dateB ? 1 : dateA < dateB ? -1 : 0;
    });

    let prevRow: any = undefined;
    let backgroundColor = Colors.WHITE;
    const format = config.dateFormatWithDay ? config.dateFormatWithDay : 'ddd DD/MM/YYYY';
    return (
      <ContrainerCheckbox>
        {dutyList.map((d) => {
          if (prevRow) {
            if (prevRow!.duty!.dutyDate.date != d.duty!.dutyDate.date) {
              backgroundColor = this.toggleColor(backgroundColor);
            }
          }
          prevRow = d;
          return (
            <div style={{ background: backgroundColor }} key={d.dutyAssignmentId}>
              <Checkbox
                key={d.dutyAssignmentId}
                onChange={() => this.onCheckboxChange(d.dutyAssignmentId)}
                checked={selectedDuties.includes(d.dutyAssignmentId)}
                disabled={this.props.disable}
              >
                {d.duty!.dutyType!.name} - {moment(d.duty!.dutyDate.date).format(format)}
              </Checkbox>
            </div>
          );
        })}
      </ContrainerCheckbox>
    );
  }
}

export default withTranslate(DutySelection);
